const PLACE_OCI_ORDER = 'PLACE_OCI_ORDER';

export {
  PLACE_OCI_ORDER,
};
